/* eslint-disable no-console */
import { reportServerError } from '@/lib/faro-server';

// Single owner of console output in this app.
//
// Development logs everything to the console. Production keeps `error` and
// `warn` on the console because that is the signal path:
// - in the browser Grafana Faro's console instrumentation reports it (see
//   src/instrumentation-client.ts), so call sites that don't report explicitly
//   (see src/lib/push.ts, src/lib/posthog/posthog-events.ts) still get reported;
// - on the server it goes to stdout (what the platform logs collect) and
//   `logger.error` is also posted to the Faro collector, because the browser
//   SDK cannot run there (see src/lib/faro-server.ts).
// `info`/`debug` stay development-only — they are noise, not signal.
const isDev = process.env.NODE_ENV !== 'production';
const isServer = typeof window === 'undefined';

export const logger = {
  error: (...args: unknown[]) => {
    console.error(...args);
    if (isServer && !isDev) {
      const error = args.find((arg) => arg instanceof Error);
      const label = args.find((arg) => typeof arg === 'string');
      reportServerError(error ?? label ?? args[0], {
        source: 'logger',
        label: typeof label === 'string' ? label : undefined
      });
    }
  },
  warn: (...args: unknown[]) => {
    console.warn(...args);
  },
  info: (...args: unknown[]) => {
    if (isDev) console.info(...args);
  },
  debug: (...args: unknown[]) => {
    if (isDev) console.debug(...args);
  }
};
